const viewport = () => {
    let e = window, a = 'inner'
    if (!('innerWidth' in window)) {
        a = 'client'
        e = document.documentElement || document.body
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] }
}

const scrollMe = function (elem) {
    let $ = window.jQuery;

    elem.on('click', function (e) {
        e.preventDefault();

        let section = $($(this).attr('href'));
        let delta = $(this).attr('delta');

        delta = (typeof delta !== typeof undefined && delta !== false) ? delta : 0;

        scrollTo(section, delta);
    });
};
const scrollTo = function (section, delta = 0) {
    let $ = window.jQuery;

    if (section.length > 0) {
        let wpadminbar_height = $('#wpadminbar').length ? $('#wpadminbar').height() : 0;
        wpadminbar_height = viewport().width <= 600 ? 0 : wpadminbar_height;

        let header_height = $('header .header__top').outerHeight(),
            nav_height = viewport().width >= 1024 && $(window).scrollTop() > section.offset().top ? 60 : 0,
            start_pos = wpadminbar_height + header_height + nav_height,
            start_to = section.offset().top - start_pos + 1 - delta;

        start_to = start_to < 0 ? 0 : start_to

        $('html,body').stop();
        $('html,body').animate({ scrollTop: start_to }, 500, 'swing');
    }
};

export { viewport, scrollMe, scrollTo }
